import Flashbar from '@amzn/awsui-components-react/polaris/flashbar';
import React from 'react';

interface AjaxStatusIndicatorProps {
    loading: boolean;
    errorMessage?: string;
    className?: string;
}

/**
 * This component shows two sections based on its properties: Loading Bar and Error Bar.
 * Both sections are independent and can be shown at the same time.
 *
 * Error message is shown whenever the string message is not empty.
 * Loading bar is shown whenever the loading flag is true.
 */
export default class AjaxStatusIndicator extends React.Component<AjaxStatusIndicatorProps> {
    render(): JSX.Element {
        return (
            <div>
                {
                    this.props.loading &&
                    <Flashbar
                        id='flashbar-loading'
                        className={this.props.className}
                        items={[
                            {
                                type: 'info',
                                content: 'Loading...',
                                loading: true
                            },
                        ]}/>
                }
                {
                    this.props.errorMessage &&
                    <Flashbar
                        id='flashbar-error'
                        className={this.props.className}
                        items={[
                            {
                                type: 'error',
                                content: this.props.errorMessage || 'Internal error',
                                dismissible: true,
                            },
                        ]}
                    />
                }
            </div>
        )
    }
}
